// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"164":"component---src-pages-hourly-calculator-tsx","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"164":"8e9ec726d18658d8fce6","218":"e1efed185d4c6137e611","691":"23bb98d90e1372ca2089"}[chunkId] + ".js";
};